/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  version: "v3.4",
  apiServerUrl: "https://ilstage.shawarmer.com/api/v1/OpsPortal",
  callCenterApiUrl: "https://staging.api.shawarmer.com/cc-api",
  clientId: "43cf50e0-4e4b-4c3f-ab74-5014f67d893d",
  redirectUri: "/cc/",
  postLogoutRedirectUri: "/",
  systemUserId: 7,
  donationSystemUserId: 20128,
  defaultDonationCustomerId: 57,
  donationSdmCustomerId: 101487,
  donationSdmDeliveryAddressId: 153515,

  cateringSystemUserId: 20128,
  defaultCateringCustomerId: 61,
  cateringSdmCustomerId: 101497,
  cateringSdmDeliveryAddressId: 153576,

  menuId: 39,
  cashPaymentMethod: 9,
  onlinePaymentMethod: 17,
  donationPaymentMethod: 36,
  appBaseHref: "/cc/",
  deliveryOrderMode: 1,
  pickupOrderMode: 3,
  jahezSystemUserId: 87,
  hsSystemUserId: 94,
  noonSystemUserId: 20120,
  kioskSystemUserId: 20125,
  ninjaSystemUserId: 20130,
  keetaSystemUserId: 20133,
  enableCash: true,
  sources: [
    {
      id: 2,
      name: "Mobile",
      sdmSourceId: 2,
      menuId: 39,
      showInCharts: true,
      type: "Main",
    },
    {
      id: 7,
      name: "InStore",
      sdmSourceId: 18,
      menuId: 39,
      showInCharts: false,
      type: "Main",
    },
    {
      id: 94,
      name: "HungerStation",
      sdmSourceId: 5,
      menuId: 59,
      showInCharts: true,
      type: "Aggregator",
    },
    {
      id: 87,
      name: "Jahez",
      sdmSourceId: 9,
      menuId: 59,
      showInCharts: true,
      type: "Aggregator",
    },
    {
      id: 10105,
      name: "Mrsool",
      sdmSourceId: 17,
      menuId: 59,
      showInCharts: true,
      type: "Aggregator",
    },
    {
      id: 97,
      name: "ToYou",
      sdmSourceId: 15,
      menuId: 59,
      showInCharts: true,
      type: "Aggregator",
    },
    {
      id: 20109,
      name: "TheChefz",
      sdmSourceId: 21,
      menuId: 59,
      showInCharts: true,
      type: "Aggregator",
    },
    {
      id: 20112,
      name: "Shgardi",
      sdmSourceId: 23,
      menuId: 59,
      showInCharts: true,
      type: "Aggregator",
    },
    {
      id: 20120,
      name: "Noon",
      sdmSourceId: 23,
      menuId: 59,
      showInCharts: true,
      type: "Aggregator",
    },
    {
      id: 20130,
      name: "Ninja",
      sdmSourceId: 23,
      menuId: 59,
      showInCharts: true,
      type: "Aggregator",
    },
    {
      id: 20133,
      name: "Keeta",
      sdmSourceId: 23,
      menuId: 59,
      showInCharts: true,
      type: "Aggregator",
    },
    {
      id: 20110,
      name: "Whatsapp",
      sdmSourceId: 22,
      menuId: 169,
      showInCharts: true,
      type: "Menu",
    },
    {
      id: 100,
      name: "Hidden Menu",
      sdmSourceId: 100,
      menuId: 89,
      showInCharts: false,
      type: "Menu",
    },
  ],
};
